import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'check-links',
  templateUrl: './check-links.component.html',
  styleUrls: ['./check-links.component.scss']
})

export class CheckLinksComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	loading = false
	error = false

	@Input() course = 0
	links: any[] = []

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	getLinksSub = new Subscription
	checkLinkSub = new Subscription
	showHeadingSub = new Subscription

	constructor(private dataService: ApiService) { }

	ngOnInit(): void {
		this.loading = true
	}

	ngAfterViewInit(): void { }

	ngOnChanges(): void {
		this.getLinks(this.course)
	}

	ngOnDestroy(): void {
		this.getLinksSub?.unsubscribe()
		this.checkLinkSub?.unsubscribe()
		this.showHeadingSub?.unsubscribe()
	}

	getLinks(course: number) {
		this.getLinksSub = this.dataService.getLinks(course)
		.subscribe(
			data => {
				console.log(data)
				this.loading = false
				this.error = false
				this.links = data

				this.links.forEach(async (link) => {
					console.log(link)

					await this.dataService.checkLink(link.url)
					.toPromise().then(
						data => {
							console.log(data)
							link.checked = data.checked
							link.status = data.status
							link.valid = data.valid
						},
						error => {
							console.log(error)
							link.checked = true
							link.status = 0
							link.valid = false
						}
					)
				})
			},
			error => {
				console.log(error)
				this.loading = false
				this.error = true
			},
		)
	}

	showHeading(heading: number, link: any) {
		const dialog = document.getElementById('link-heading-dialog') as HTMLDialogElement
		const dialogTitle = dialog.getElementsByTagName('h4').item(0)! as HTMLHeadingElement
		const dialogText = dialog.getElementsByTagName('p').item(0)! as HTMLParagraphElement

		dialogTitle.innerText = ""
		dialogText.innerHTML = "<i class='fas fa-spinner fa-spin'></i><span>Cargando...</span>"

		this.dataService.showHeading(heading)
		.subscribe(
			data => {
				console.log(data)

				let headingName = data.name
				let headingContent = data.content.replace(link, `<span style='background-color: yellow'>${link}</span>`)
				dialog.getElementsByTagName('h4').item(0)!.innerHTML = headingName
				dialog.getElementsByTagName('p').item(0)!.innerHTML = headingContent
			},
			error => {
				console.log(error)
			},
		)
		dialog?.showModal()

		return false
	}

}
